import { styled } from '@linaria/react'

export const PopupUnderLayerSC = styled.div<{
  position?: 'fixed' | 'absolute' | 'relative'
  transform?: string
  top?: string
  left?: string
  display?: string
  bottom?: string
  right?: string
}>`
  position: ${({ position }) => position || 'static'};
  top: ${({ top }) => top || 'unset'};
  left: ${({ left }) => left || 'unset'};
  bottom: ${({ bottom }) => bottom || 'unset'};
  right: ${({ right }) => right || 'unset'};

  display: ${({ display }) => display || 'block'};

  transform: ${({ transform }) => transform || 'none'};
  z-index: 1;
`
